import { IFiterSearch } from 'redhotpie-shared-lib/interfaces/IFilter';
import { ILocation } from 'redhotpie-shared-lib/interfaces/IGroup';

export default class FilterSearch {
  searchGuid: string;
  type: string;
  orderByType: string;
  niche: string;
  userName: string;
  memberType: number;
  seekingMemberType: number;
  minAge: number;
  maxAge: number;
  countryId: number;
  stateId: number;
  postCodeAllId: number;
  googleMapPlace?: ILocation;
  searchGeoPoint?: ILocation;
  searchRadius: number;
  onlineNow: boolean;
  hasValidations: boolean;
  withPhotos: boolean;
  isVerified: boolean;
  ethnicity: string[];
  bodyTypes: string[];
  sexual: string[];
  participationLevel: string[];
  safeSex: string[];
  maritalStatus: string[];
  endowment: string[];
  height: string[];
  sexualInterests: string[];
  sexualPreference: string[];
  fetish: string[];
  intentions: string[];
  cupSize: string[];
  smoking: string[];
  pubicHair: string[];

  constructor() {
    this.searchGuid = '';
    this.type = '';
    this.orderByType = '';
    this.niche = '';
    this.userName = '';
    this.memberType = 0;
    this.seekingMemberType = 0;
    this.minAge = 0;
    this.maxAge = 0;
    this.countryId = 0;
    this.stateId = 0;
    this.postCodeAllId = 0;
    this.googleMapPlace = undefined;
    this.searchGeoPoint = undefined;
    this.searchRadius = 0;
    this.onlineNow = false;
    this.hasValidations = false;
    this.withPhotos = false;
    this.isVerified = false;
    this.ethnicity = [];
    this.bodyTypes = [];
    this.sexual = [];
    this.participationLevel = [];
    this.safeSex = [];
    this.maritalStatus = [];
    this.endowment = [];
    this.height = [];
    this.sexualInterests = [];
    this.sexualPreference = [];
    this.fetish = [];
    this.intentions = [];
    this.cupSize = [];
    this.smoking = [];
    this.pubicHair = [];
  }

  static mappingObject(props: any): IFiterSearch {
    const obj = new FilterSearch();
    obj.searchGuid = props.SearchGuid || '';
    obj.type = props.Type || '';
    obj.orderByType = props.OrderByType || '';
    obj.niche = props.Niche || '';
    obj.userName = props.UserName || '';
    obj.memberType = props.MemberType || 0;
    obj.seekingMemberType = props.SeekingType || 0;
    obj.minAge = props.MinAge || 0;
    obj.maxAge = props.MaxAge || 0;
    obj.countryId = props.CountryID || 0;
    obj.stateId = props.StateID || 0;
    obj.postCodeAllId = props.PostCodeAllID || 0;
    obj.googleMapPlace =
      props.GoogleMapPlace && props.GoogleMapPlace.hasOwnProperty('PlacesId') && props.GoogleMapPlace.hasOwnProperty('Types')
        ? {
            placeId: props?.GoogleMapPlace?.PlacesId || '',
            types: props?.GoogleMapPlace?.Types,
          }
        : undefined;
    obj.searchGeoPoint =
      props.SearchGeoPoint && props.SearchGeoPoint.hasOwnProperty('Latitude') && props.SearchGeoPoint.hasOwnProperty('Longitude')
        ? {
            lat: props.SearchGeoPoint.Latitude,
            lng: props.SearchGeoPoint.Longitude,
          }
        : undefined;
    obj.searchRadius = props.SearchRadius || 0;
    obj.onlineNow = props.OnlineNow || false;
    obj.withPhotos = props.WithPhotos || false;
    obj.hasValidations = props.HasValidations || false;
    obj.isVerified = props.IsVerified || false;
    obj.ethnicity = props.Race || [];
    obj.bodyTypes = props.BodyType || [];
    obj.sexual = props.SexualOrientation || [];
    obj.participationLevel = props.Participation || [];
    obj.safeSex = props.SafeSex || [];
    obj.maritalStatus = props.MaritalStatus || [];
    obj.endowment = props.EndowmentLength || [];
    obj.height = props.Height || [];
    obj.sexualInterests = props.SexualIntererest || [];
    obj.sexualPreference = props.SexualPreference || [];
    obj.fetish = props.FetishInterest || [];
    obj.intentions = props.Intention || [];
    obj.cupSize = props.CupSize || [];
    obj.smoking = props.Smoking || [];
    obj.pubicHair = props.PubicHair || [];

    return obj;
  }
}
